// extracted by mini-css-extract-plugin
module.exports = {"main":"CustomButton_main__18XAH"};